<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row class="mx-2">
          <v-col>
            <v-tabs v-model="tab" height="64" background-color="transparent">
              <v-tab v-for="tabTitle in tabTitles" :key="tabTitle.title">
                <v-card-title class="pa-0">
                  {{ tabTitle.title }}
                </v-card-title>
              </v-tab>
            </v-tabs>
          </v-col>
        </v-row>
        <v-tabs-items v-model="tab" class="transparent-background-color pb-4 mt-1">
          <!-- 拣货策略 -->
          <v-tab-item>
            <v-card v-show="!currentItemMode" class="mx-3">
              <v-subheader>
                <h3>{{ $t("WaveRules.PickStrategy.title") }}</h3>
                <v-spacer />
                <v-btn
                  small
                  color="primary"
                  @click.stop="
                    currentItemMode = 'new';
                    currentItem = { id: 0 };
                  "
                  class="ms-1 mx-1"
                >
                  <v-icon x-small class="pe-1">fa-plus</v-icon>
                  {{ $t("CRUD.newInfo", [$t("WaveRules.ObjectName")]) }}
                </v-btn>
                <v-btn
                  small
                  dark
                  color="action"
                  @click.stop="
                    $router.push('/stocks/wave-settings?stock_id=' + stock_id)
                  "
                  class="ms-1 mx-1"
                >
                  {{ $t("WaveRules.actions.generalSetting") }}
                </v-btn>
              </v-subheader>

              <v-data-table
                :headers="headers"
                :items="wave_rulers"
                :page.sync="paging.page"
                :server-items-length="paging.count"
                :loading="loading"
                multi-sort
                class="px-4"
                :footer-props="$t('$config.footer-props')"
              >
                <template v-slot:header.actions="{ header }">
                  {{ header.text }}
                  <v-icon x-small>fa-sliders-h</v-icon>
                </template>
                <template v-slot:item.add_type="{ item }">
                  {{ item.add_type | pickOrderTypesText }}
                </template>
                <template v-slot:item.pick_type="{ item }">
                  {{ item.pick_type | pickOrderWaysText }}
                </template>
                <template v-slot:item.area_split_type="{ item }">
                  {{ item.area_split_type | areaSplitRulersText }}
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    label
                    :color="item.status | waveRulerStatusColor"
                    :text-color="item.status | waveRulerStatusTextColor"
                  >
                    {{ item.status | waveRulerStatusText }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="secondary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          currentItemMode = 'view';
                          currentItem = item;
                        "
                        >fa-file-alt
                      </v-icon>
                    </template>
                    <span>{{
                      $t("CRUD.editInfo", [$t("WaveRules.ObjectName")])
                    }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        class="px-1 py-4 me-1"
                        @click.stop="
                          currentItemMode = 'edit';
                          currentItem = item;
                        "
                        >fa-pencil-alt
                      </v-icon>
                    </template>
                    <span>{{
                      $t("CRUD.editInfo", [$t("WaveRules.ObjectName")])
                    }}</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card>
            <WaveRulerDetail
              v-show="currentItemMode"
              v-model="currentItem"
              :mode="currentItemMode"
              v-on:mode="currentItemMode = $event"
              v-on:save="getWaveRulersFromAPI()"
            />
          </v-tab-item>
          <!-- 上架策略 -->
          <v-tab-item>
            <v-card class="mx-3">
              <v-list rounded>
                <v-subheader>
                  <h3>{{ $t("WaveRules.PutawayStrategy.title") }}</h3>
                </v-subheader>
                <v-list-item-group>
                  <Draggable
                    v-model="positionShelveSort"
                    @change="datadragEnd"
                    draggable=".drag-item"
                    :animation="300"
                    disabled
                  >
                    <v-list-item
                      v-for="item in positionShelveSort"
                      :key="item.value"
                      :class="item.value == 1 ? '' : 'drag-item'"
                    >
                      <v-list-item-content>
                        <v-list-item-title>
                          <v-app-bar-nav-icon></v-app-bar-nav-icon>
                          {{ item.text }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <span class="danger--text">{{ item.hint }}</span>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </Draggable>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-tab-item>
          <!-- 库位混放策略 -->
          <v-tab-item>
            <v-card class="mx-3">
              <v-subheader>
                <h3>{{ $t("WaveRules.PositionMixedStrategy.title") }}</h3>
              </v-subheader>
              <v-row dense>
                <span class="subtitle-1 mx-8 my-4">
                  {{
                    $t("WaveRules.PositionMixedStrategy.mixed_with_materials")
                  }}
                </span>
                <v-radio-group
                  row
                  v-model="positionMixed.material_mix"
                  @change="savePositionMixed()"
                >
                  <v-radio label="是" :key="1" value="1" />
                  <v-radio label="否" :key="0" value="0" />
                </v-radio-group>
              </v-row>
              <v-row dense>
                <span class="subtitle-1 mx-8 my-4">
                  {{ $t("WaveRules.PositionMixedStrategy.mixed_with_batchs") }}
                </span>
                <v-radio-group
                  row
                  v-model="positionMixed.batch_mix"
                  @change="savePositionMixed()"
                >
                  <v-radio label="是" :key="1" value="1" />
                  <v-radio label="否" :key="0" value="0" />
                </v-radio-group>
              </v-row>
            </v-card>
          </v-tab-item>
          <!-- 补货策略 -->
          <v-tab-item>
            <v-card class="mx-3">
              <v-subheader>
                <h3>{{ $t("WaveRules.replenishmentStrategy.title") }}</h3>
                <span class="danger--text mx-3 my-1">{{
                  $t("WaveRules.replenishmentStrategy.hint")
                }}</span>
              </v-subheader>
              <v-row dense class="subtitle-1 mx-8">
                <v-radio-group
                  v-model="positionReplenishRule"
                  @change="saveReplenishmentStrategy()"
                >
                  <v-radio
                    :label="
                      $t(
                        'WaveRules.replenishmentStrategy.replenishment_strategy_one'
                      )
                    "
                    :key="1"
                    :value="1"
                  />
                  <v-radio
                    :label="
                      $t(
                        'WaveRules.replenishmentStrategy.replenishment_strategy_two'
                      )
                    "
                    :key="2"
                    :value="2"
                  />
                  <v-radio
                    :label="
                      $t(
                        'WaveRules.replenishmentStrategy.replenishment_strategy_three'
                      )
                    "
                    :key="3"
                    :value="3"
                  />
                </v-radio-group>
              </v-row>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import Breadcrumbs from "@/components/Breadcrumbs";
import WaveRulerDetail from "./plugins/Detail";
import WaveRulers from "@/api/wave_rulers";
import Stocks from "@/api/stocks";
import Draggable from "vuedraggable";

export default {
  components: {
    Breadcrumbs,
    WaveRulerDetail,
    Draggable,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stocks"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.strageticManagement"),
          disabled: true,
          href: "/stocks/wave-rulers",
        },
        {
          text: this.stock && this.stock.name ? this.stock.name : "",
          accent: true,
          disabled: false,
        },
      ];
    },

    headers: () => [
      {
        text: i18n.t("WaveRules.Fields.ruler_name"),
        align: "start",
        sortable: false,
        value: "name",
      },
      {
        text: i18n.t("WaveRules.Fields.max_order_count"),
        align: "start",
        sortable: false,
        value: "max_order_num",
      },
      {
        text: i18n.t("WaveRules.Fields.min_order_count"),
        align: "start",
        sortable: false,
        value: "min_order_num",
      },
      {
        text: i18n.t("WaveRules.Fields.pick_order_type"),
        align: "start",
        sortable: false,
        value: "add_type",
      },
      {
        text: i18n.t("WaveRules.Fields.pick_order_way"),
        align: "start",
        sortable: false,
        value: "pick_type",
      },
      {
        text: i18n.t("WaveRules.Fields.area_split_ruler"),
        align: "center",
        sortable: false,
        value: "area_split_type",
      },
      {
        text: i18n.t("WaveRules.Fields.status"),
        align: "center",
        sortable: false,
        value: "status",
      },
      {
        text: i18n.t("TableHeaders.actions"),
        align: "start",
        sortable: false,
        value: "actions",
      },
    ],

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    tab: null,
    tabTitles: [
      { title: i18n.t("WaveRules.tabTitles.pick_strategy") },
      { title: i18n.t("WaveRules.tabTitles.putaway_strategy") },
      {
        title: i18n.t("WaveRules.tabTitles.position_mixed_strategy"),
      },
      { title: i18n.t("WaveRules.tabTitles.replenishment_strategy") },
    ],
    stock_id: 0,
    stock: {},
    wave_rulers: [],
    paging: {},
    currentItemMode: null,
    currentItem: null,
    positionShelveSort: [],
    positionMixed: {
      material_mix: "0",
      batch_mix: "0",
    },
    positionReplenishRule: 1,
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      this.stock_id = Number(this.$route.query.stock_id);
      Stocks.fetchOne(this.stock_id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
      this.getWaveRulersFromAPI();
    }
    //为了防止火狐浏览器拖拽的时候以新标签打开，此代码真实有效
    document.body.ondrop = function (event) {
      event.preventDefault();
      event.stopPropagation();
    };
  },

  methods: {
    getWaveRulersFromAPI() {
      WaveRulers.fetch({ stock_id: this.stock_id }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.wave_rulers = response.data.wave_rulers;
          }
        }.bind(this)
      );
    },

    datadragEnd() {
      // 每次更新排序就自动保存
      Stocks.save(this.stock.id, {
        position_shelve_sort: this.positionShelveSort.map((shelve_sort) => {
          return shelve_sort.value;
        }),
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(
              i18n.t("WaveRules.Messages.saveSuccessMessage")
            );
          }
        }.bind(this)
      );
    },
    //自动保存库位混放策略
    savePositionMixed() {
      Stocks.save(this.stock.id, {
        position_mix_json: this.positionMixed,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(
              i18n.t("WaveRules.Messages.saveSuccessMessage")
            );
          }
        }.bind(this)
      );
    },
    //自动保存补货策略
    saveReplenishmentStrategy() {
      Stocks.save(this.stock.id, {
        position_replenish_rule: this.positionReplenishRule,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(
              i18n.t("WaveRules.Messages.saveSuccessMessage")
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {
    $route() {
      if (!this.$route.query.id) {
        this.currentItemMode = null;
        this.currentItem = null;
      }
    },
    currentItem: {
      handler() {
        if (this.currentItem) {
          this.$cacheScrollLocation();
        } else {
          this.$scrollToCachedLocation();
        }
      },
    },
    stock: {
      handler() {
        if (this.stock) {
          if (this.stock.position_shelve_sort) {
            this.positionShelveSort = this.stock.position_shelve_sort.map(
              (sort) => {
                return this.$consts.stock.position_shelve_strategy.find(
                  (item) => item.value == sort
                );
              }
            );
          } else {
            this.positionShelveSort =
              this.$consts.stock.position_shelve_strategy;
          }

          if (this.stock.position_mix_json) {
            this.positionMixed = this.stock.position_mix_json;
          }
          if (this.stock.position_replenish_rule) {
            this.positionReplenishRule = this.stock.position_replenish_rule;
          }
        }
      },
    },
  },
};
</script>
